import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingPhoto } from './types/Listing';

interface ListingPhotos {
  format: string;
  order: number[];
  rotate?: number;
}

export default (makeCall: MakeCall) =>
  (listingId: number, { order, rotate, format }: ListingPhotos) =>
    makeCall<ListingPhoto[]>('PUT', `/api/v2/listing/${listingId}/photos`, {
      data: {
        order,
        ...(rotate ? { rotate } : {}),
      },
      query: { format },
    });
